export const redirectIfNeeded = ({ pathname, devHost, isDevelopment }) => {
  const onNewPortal = pathname.startsWith("/portal");

  if (!onNewPortal && isDevelopment) {
    window.location.replace((devHost || "") + "/portal");
  }
};
